module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.3@core-js/library/modules/_library.js
// module id = 116
// module chunks = 0 1